import { instance, next } from "./base";

export const getGiftCardRequest = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/gift-card-requests", { params: { status: "pending" } })
    .catch((e) => next(e));
  return data?.data;
};

export const getGiftCardRequestHistory = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/gift-card-requests", { params: { status: "processing" } })
    .catch((e) => next(e));
  return data?.data;
};

export const getTradeMetrics = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/metrics")
    .catch((e) => next(e));
  return data?.data;
};

export const getTradeCharts = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/charts")
    .catch((e) => next(e));
  return data?.data;
};

export const getCryptoTrans = async (cryptoType, page) => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/crypto", { params: { ...(cryptoType && { cryptoType }), page } })
    .catch((e) => next(e));
  return data?.data;
};

export const getGiftCardTrans = async (transactionType, page) => {
  const { data } = await instance()
    .get("/api/v1/admin/trade/crypto", { params: { giftcard: true, page, ...(transactionType && { transactionType }) } })
    .catch((e) => next(e));
  return data?.data;
};

export const processGiftCard = async (values) => {
  const id = values.id;
  delete values.id
  const { data } = await instance()
    .patch(`/api/v1/admin/trade/gift-card/${id}/status`, values)
    .catch((e) => next(e));
  return data?.data;
};